import { Stack, Typography } from "@mui/material";

export function CalcItem({ label, value, postFix }) {
    return <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Typography fontWeight={600}>{label}:</Typography>
        <Typography color='primary' fontWeight={700} variant='h5'>
            {value}
            <Typography variant='span' color='textSecondary'>
                {postFix}
            </Typography>
        </Typography>
    </Stack>
}